import React from 'react';
import { MdArrowForward } from 'react-icons/md';

const WorkflowTimeline = ({ currentStage }) => {
  const stages = [
    { key: 'SHORTLISTED', label: 'Shortlisted', icon: '✓' },
    { key: 'AGREEMENT', label: 'Agreement', icon: '📄' },
    { key: 'INTERVIEW', label: 'Interview', icon: '◉' },
    { key: 'OFFER_LETTER', label: 'Offer Letter', icon: '📋' },
    { key: 'PAYMENT', label: 'Payment', icon: '₹' },
    { key: 'DOCUMENT_VERIFICATION', label: 'Documents', icon: '☑' },
    { key: 'EXAM', label: 'Exam', icon: '✍' },
    { key: 'MEDICAL', label: 'Medical', icon: '+' },
    { key: 'TPC_PRACTISING', label: 'TPC Practising', icon: '📑' },
    { key: 'ESD_APPROVAL', label: 'ESD Approval', icon: '✔' },
    { key: 'VISA_PROCESS', label: 'Visa', icon: '⚐' },
    { key: 'PRE_DEPARTURE', label: 'Pre-Departure', icon: '✈' },
    { key: 'CLEARANCE', label: 'Clearance', icon: '✓' },
    { key: 'TICKET', label: 'Ticket', icon: '🎫' },
    { key: 'DEPARTURE', label: 'Departure', icon: '→' },
    { key: 'COMPLETED', label: 'Completed', icon: '✓' }
  ];

  const normalizedCurrentStage = currentStage;

  const currentIndex = stages.findIndex(s => s.key === normalizedCurrentStage);
  const isRejected = currentStage === 'REJECTED';
  const isWithdrawn = currentStage === 'WITHDRAWN';

  return (
    <div className="py-6 px-5 bg-surface rounded-xl my-4 shadow-sm border border-border-light">
      {isRejected ? (
        <div className="flex flex-col items-center py-10 text-center">
          <span className="text-[56px] mb-4 text-status-error">✗</span>
          <span className="text-xl font-semibold text-status-error">Application Rejected</span>
        </div>
      ) : isWithdrawn ? (
        <div className="flex flex-col items-center py-10 text-center">
          <span className="text-[56px] mb-4 text-orange-600">⚠</span>
          <span className="text-xl font-semibold text-orange-600">Application Withdrawn</span>
        </div>
      ) : (
        <div className="flex items-center justify-between overflow-x-auto py-5 px-2.5 gap-2 [&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-track]:bg-background-light [&::-webkit-scrollbar-track]:rounded [&::-webkit-scrollbar-thumb]:bg-border [&::-webkit-scrollbar-thumb]:rounded [&::-webkit-scrollbar-thumb:hover]:bg-text-secondary lg:py-4 lg:px-2 lg:gap-1 md:justify-start">
          {stages.map((stage, index) => {
            const isCompleted = index < currentIndex;
            const isCurrent = index === currentIndex;
            const isPending = index > currentIndex;

            return (
              <React.Fragment key={stage.key}>
                <div
                  className={`flex flex-col items-center relative min-w-[90px] shrink-0 lg:min-w-[70px] md:min-w-[60px]`}
                >
                  <div className={`w-14 h-14 rounded-full flex items-center justify-center text-[22px] mb-3 transition-all duration-300 ease-in-out z-[2] border-[3px] border-transparent lg:w-12 lg:h-12 lg:text-lg md:w-11 md:h-11 md:text-base ${isCompleted ? 'bg-accent-green text-white shadow-[0_4px_12px_rgba(107,127,92,0.3)] border-accent-green' :
                    isCurrent ? 'bg-accent-terracotta text-white shadow-[0_6px_16px_rgba(193,122,92,0.4)] border-accent-terracotta animate-pulse scale-110' :
                      'bg-[#F5F5F5] text-[#BDBDBD] border-[#E0E0E0]'
                    }`}>
                    {isCompleted ? '✓' : stage.icon}
                  </div>
                  <div className={`text-xs text-center text-text-secondary font-medium max-w-[90px] leading-[1.4] break-words md:text-[10px] ${isCurrent ? 'text-primary font-bold' :
                    isCompleted ? 'text-accent-green-dark font-semibold' : ''
                    }`}>{stage.label}</div>
                </div>
                {index < stages.length - 1 && (
                  <div className={`flex items-center justify-center mx-1 shrink-0 transition-all duration-300 ease-in-out ${isCompleted ? 'text-accent-green animate-slideIn' : 'text-[#E0E0E0]'
                    }`}>
                    <MdArrowForward size={24} className="lg:w-5 lg:h-5 md:w-[18px] md:h-[18px]" />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WorkflowTimeline;
